import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "SearchMarkerTile": () => import("./components/search/SearchMarkerTile.vue"),
    "AddMarkerFormTile": () => import("./components/add-marker/AddMarkerFormTile.vue"),
    "AddMarkerMapTile": () => import("./components/add-marker/AddMarkerMapTile.vue"),
    "MarkerDetailsFormTile": () => import("./components/marker-details/MarkerDetailsFormTile.vue"),
    "MarkerDetailsMapTile": () => import("./components/marker-details/MarkerDetailsMapTile.vue"),
    "SearchCoords": () => import("./components/search-coords/SearchCoords.vue"),
    "EditCoords": () => import("./components/edit-coords/EditCoords.vue"),
    "ZoomPicture": () => import("./components/zoom-picture/ZoomPicture.vue"),
};

export default globals;
